import { jsx as _jsx } from "react/jsx-runtime";
const defaultRadius = 3;
const MetricsCircle = ({ cx, cy, radius }) => (_jsx("g", { className: "circle", children: _jsx("circle", { cx: cx, cy: cy, r: radius !== undefined ? radius : defaultRadius }) }));
export default MetricsCircle;
